import React from "react";
import { Button, Space, Tooltip, Upload, Typography } from "antd";
import { FolderOpenOutlined, PictureOutlined } from "@ant-design/icons";

const ChatImagePickerMobile = ({ viewModel }) => {
    const actionButtonStyle = {
        borderRadius: 999,
        minWidth: 40,
        width: 40,
        height: 40,
        padding: 0,
        ...(viewModel.buttonStyle || {}),
    };

    return (
        <Space size={8} align="center">
            <Upload
                showUploadList={false}
                multiple
                accept={viewModel.acceptValue}
                beforeUpload={viewModel.handleBeforeUpload}
                disabled={viewModel.loading}
            >
                <Button size={viewModel.buttonSize || "middle"} style={actionButtonStyle} icon={<PictureOutlined />} />
            </Upload>

            <Tooltip title="Chọn từ thư viện">
                <Button
                    size={viewModel.buttonSize || "middle"}
                    style={actionButtonStyle}
                    icon={<FolderOpenOutlined />}
                    onClick={viewModel.openLibrary}
                    disabled={viewModel.loading}
                />
            </Tooltip>

            {viewModel.imageCount > 0 ? (
                <Typography.Text type="secondary" style={viewModel.counterTextStyle || { fontSize: 13 }}>
                    {viewModel.imageCount} ảnh
                </Typography.Text>
            ) : null}
        </Space>
    );
};

export default ChatImagePickerMobile;